import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { throwError } from 'rxjs';
import { User, UserDetails} from '../models/index';
import { SubSink } from 'subsink';
import { AlertService } from '@core/services/alert.service';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { SelectAccountService } from '@core/services/select-account.service';

@Injectable()
export class ProfileService {
  currentProfile: User;
  userDetails: UserDetails;
  private subs = new SubSink();
  churchAccounts = [];
  @Output() changeEvent: EventEmitter<User> = new EventEmitter();
  @Output() changeUserEvent: EventEmitter<UserDetails> = new EventEmitter();
  constructor(private http: HttpClient, private alertService: AlertService, protected selectAccountService: SelectAccountService) {
    this.currentProfile = new User();
    this.userDetails = new UserDetails();
  }

  getToken() {
    return localStorage.getItem('token');
  }
  logout() {
    let param = new HttpParams();
    param = param.append('source', 'EventManagement');
    return this.http.get(environment.services.user.url + 'logout', {params: param});
  }

  profileUpdate() {
    this.changeEvent.emit(this.currentProfile);
    this.changeUserEvent.emit(this.userDetails);
  }

  /**
   * It Authenticate the user and creates a session through user service.
   * @author Balakrishnan Rajendran, on Apr 29, 2020
   */
  public socialLogin(data: any) {
    return this.http.post(environment.services.user.url + 'sociallogin', data).pipe(
      retry(1), catchError(error => {
        return throwError(error.message);
      }));
  }

  /**
   * Retrieves the event images based on the event category selected
   * @author Hayley Shuler May-6-2020
   * @author Balakrishnan Rajendran modified on Jun-8-2020
   */
  fetchOrCreateUserId(data) {
    return this.http.post(environment.services.eventmanagement.url + "fetchOrCreateUserId", data);
  }

  registration(data: any) {
    return this.http.post(environment.services.user.url + "register", data);
  }

  checkUsersChurchAccount(contactId: any) {
    this.subs.add(this.checkUserChurchAccount(contactId).subscribe((result: any) => {
      if (result) {
        if (result.churchList.totalSize > 0) {
          for (let i = 0; i < result.churchList.records.length; i++) {
            let account = {
              accountId: result.churchList.records[i].npe5__Organization__c,
              accountName: result.churchList.records[i].npe5__Organization__r.Name,
              city: result.churchList.records[i].npe5__Organization__r.Physical_City__c,
              country: result.churchList.records[i].npe5__Organization__r.PhysicalCountry__c,
              postalCode: result.churchList.records[i].npe5__Organization__r.Physical_Zip__c,
              state: result.churchList.records[i].npe5__Organization__r.Physical_State__c,
              intactId: result.churchList.records[i].npe5__Organization__r.Mailing_Address_Book__c
            }
            let index = this.churchAccounts.findIndex(church => church.accountId == account.accountId);
            if (index == -1) {
              this.churchAccounts.push(account);
            }
          }
        } else {
        }
        if (this.churchAccounts.length > 0) {
          this.selectAccountService.info(this.churchAccounts, true);
        }
      }
    }));
  }

  checkUserChurchAccount(contactId) {
    let param = new HttpParams();
    param = param.append('contactId', contactId);
    return this.http.get(environment.services.church.url + 'fetchUserChurchAccounts', { params: param });
  }
}
